import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

// App-level safety net: prevents a single component crash from white-screening
// the whole app. Auto-resets when `resetKey` changes (e.g. on route change).
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught an error:', error, info);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center" data-testid="error-boundary">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-100 text-rose-500">
            <AlertTriangle className="h-7 w-7" />
          </div>
          <div>
            <h2 className="font-display text-lg font-semibold text-foreground">Une erreur est survenue</h2>
            <p className="mt-1 max-w-md text-sm text-muted-foreground break-words">
              Cette section n'a pas pu s'afficher correctement. Vous pouvez réessayer ou recharger la page.
            </p>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" className="gap-1.5" onClick={() => this.setState({ hasError: false })} data-testid="error-boundary-retry">
              <RotateCcw className="h-4 w-4" /> Réessayer
            </Button>
            <Button className="text-white" style={{ background: 'var(--tenant-accent-500)' }} onClick={() => window.location.reload()}>
              Recharger la page
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
